import {createContext, useContext} from 'react';
import {AppContextType} from './types';

// Create Context
export const AppContext = createContext<AppContextType>({} as AppContextType);

// Encapsulated context hook
export const useAppContext = () => useContext(AppContext);
